import { render, staticRenderFns } from "./regional-authorized.vue?vue&type=template&id=6c4901b8&scoped=true"
import script from "./regional-authorized.vue?vue&type=script&lang=js"
export * from "./regional-authorized.vue?vue&type=script&lang=js"
import style0 from "./regional-authorized.vue?vue&type=style&index=0&id=6c4901b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4901b8",
  null
  
)

export default component.exports